const getCashTypeForShift = (cashTypes, total) => {
  const result =
    cashTypes.map(c => ({
      type: c.value,
      amount:
        Number(c.amount) > Number(total)
          ? Number(total)
          : Number(c.amount)
    }))

  return result
}

export default getCashTypeForShift